export default "__VITE_ASSET__BYKbPgHs__"